import { WorkspaceService } from './workspace.service';
import { ManagementTypeService } from './management-type.service';
import { PartnerService } from './partner.service';
import { SubscriptionPlanService } from './subscription-plan.service';

export const services = [
  WorkspaceService,
  ManagementTypeService,
  PartnerService,
  SubscriptionPlanService,
];
